import CostList from 'components/common/CostList';
import CostListItem from 'components/common/CostListItem';
import React from 'react';

interface Props {
  electricity: number;
  insurance: number;
  maintenance: number;
  fellesutgifter: number;
  kommunaleutgifter: number;
  className?: string;
}

const CostOverview = ({
  electricity,
  insurance,
  maintenance,
  fellesutgifter,
  kommunaleutgifter,
}: Props): JSX.Element => {
  return (
    <CostList>
      <CostListItem description="Strømutgift (estimert gjennomsnitt pr. mnd)" amount={electricity} />
      <CostListItem description="Forsikringspremie (estimert pr. mnd)" amount={insurance} />
      <CostListItem description="Vedlikeholdskostnad (estimert pr. mnd)" amount={maintenance} />
      <CostListItem description="Fellesutgifter (pr. mnd)" amount={fellesutgifter} />
      <CostListItem description="Kommunale avgifter (pr. mnd)" amount={kommunaleutgifter} />
    </CostList>
  );
};

export default CostOverview;
